// reducer.js
import {
  ADD_TEAM_MEMBER_REQUEST,
  ADD_TEAM_MEMBER_SUCCESS,
  ADD_TEAM_MEMBER_FAILURE,
  UPDATE_TEAM_MEMBER_REQUEST,
  UPDATE_TEAM_MEMBER_SUCCESS,
  UPDATE_TEAM_MEMBER_FAILURE,
  DELETE_TEAM_MEMBER_REQUEST,
  DELETE_TEAM_MEMBER_SUCCESS,
  DELETE_TEAM_MEMBER_FAILURE,
  GET_TEAM_MEMBERS_REQUEST,
  GET_TEAM_MEMBERS_SUCCESS,
  GET_TEAM_MEMBERS_FAILURE,
} from './actionTypes'

const initialState = {
  members: [],
  loading: false,
  error: null,
}

const teamMemberReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TEAM_MEMBERS_REQUEST:
    case ADD_TEAM_MEMBER_REQUEST:
    case UPDATE_TEAM_MEMBER_REQUEST:
    case DELETE_TEAM_MEMBER_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case GET_TEAM_MEMBERS_SUCCESS:
      return {
        ...state,
        loading: false,
        members: action.payload,
      }
    case ADD_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case UPDATE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case DELETE_TEAM_MEMBER_SUCCESS:
      return {
        ...state,
        loading: false,

      }
    case GET_TEAM_MEMBERS_FAILURE:
    case ADD_TEAM_MEMBER_FAILURE:
    case UPDATE_TEAM_MEMBER_FAILURE:
    case DELETE_TEAM_MEMBER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

export default teamMemberReducer
